import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '@environment';

@Component({
    selector: 'app-cart-view-item-error',
    templateUrl: './cart-view-item-error.component.html',
    styleUrls: ['./cart-view-item-error.component.scss'],
    standalone: true
})
export class CartViewItemErrorComponent implements OnChanges {
    @Input() item: any = {};
    @Output() reviewItem = new EventEmitter<string>();

    type = null; //item or customization
    errorMessage = null;
    DEPLOY_URL = environment.DEPLOY_URL;

    constructor() {}

    ngOnChanges() {
        if (Object.keys(this.item)?.length) {
            const { type, error_msg } = this.item;
            this.type = type;
            this.errorMessage = error_msg;
        } else {
            this.type = null;
            this.errorMessage = null;
        }
    }

    ctaAction() {
        this.reviewItem.emit(this.type);
    }
}
